import React, { useEffect, useRef, useState } from "react";

import TestimonialCarousel from "./TestimonialCarousel";

function SubTestimonial(props) {
  let rs = props.rs;
  let colordata = props.colordata;

  const [currentIndex, setCurrentIndex] = useState(0);
  const [testimonials, setTestimonials] = useState([]);
  const [testimonialsLength, setTestimonialsLength] = useState([]);
  const touchStartX = useRef(0);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    const touchEndX = e.touches[0].clientX;
    const deltaX = touchEndX - touchStartX.current;

    if (Math.abs(deltaX) > 50) {
      setCurrentIndex((prev) =>
        deltaX > 0
          ? Math.max(prev - 1, 0)
          : Math.min(prev + 1, testimonials.length - 1)
      );
    }
  };

  const handleTouchEnd = () => {
    touchStartX.current = 0;
  };

  useEffect(() => {
    if (rs) {
      if (rs?.testimonialObj?.content) {
        let parsedContent = JSON.parse(rs.testimonialObj.content);
        if (parsedContent?.length > 0) {
          setTestimonials(parsedContent);
          setTestimonialsLength(parsedContent.length);
        }
      }
    }
  }, [rs]);

  return (
    <>
      {testimonials && testimonials.length > 0 && (
        <article
          className="testimoniyalbox sec"
          style={{
            backgroundColor: colordata?.dynamicBackgroundColor || "",
          }}
        >
          <h3
            className="sectitle testimonial"
            style={{
              color: colordata?.dynamicTextDescriptionColor || "",
            }}
          >
            Testimonial
          </h3>

          <div>
            <TestimonialCarousel
              testimonials={testimonials}
              currentElem={currentIndex}
              handleTouchStart={handleTouchStart}
              handleTouchMove={handleTouchMove}
              handleTouchEnd={handleTouchEnd}
              style={{
                color: colordata?.dynamicTextDescriptionColor || "",
              }}
              colordata={colordata}
            />
          </div>
        </article>
      )}
    </>
  );
}

export default SubTestimonial;
